export const MassInputValidator = (params) => {
  return (value) => {
    let minimumInvoices = 2
    if (!!params && !!params.minimumInvoices) {
      minimumInvoices = params.minimumInvoices
    }
    let tempArray = value.trim().replace(/(^[ \t]*\n)/gm, '').split(/\r?\n/).map(string => string.trim())
    let retValue = true
    let isDuplicate = []
    if (tempArray.length >= minimumInvoices) {
      Array.from(tempArray).forEach(row => {
        let temp = row.trim().match(/\S+/g)
        let hasWhitespace = /\s/g.test(row)
        let amount, invoiceId
        if (!hasWhitespace) {
          invoiceId = row
          amount = ''
        } else {
          amount = temp[1]
          invoiceId = temp[0]
        }
        if (invoiceId === '') {
          retValue = false
        } else if (temp.length > 2) {
          retValue = false
        } else if (typeof isDuplicate[invoiceId] !== 'undefined') {
          retValue = false
        } else if (amount !== '' && isNaN(amount) && amount !== 0) {
          retValue = false
        } else {
          isDuplicate[temp[0]] = true
        }
      })
    } else {
      retValue = false
    }
    return retValue
  }
}

export default { MassInputValidator }



// WEBPACK FOOTER //
// ./src/components/home/group-settlement/validators/index.js